import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=221d4923&"
import script from "./Box.vue?vue&type=script&lang=ts&"
export * from "./Box.vue?vue&type=script&lang=ts&"
import style0 from "./Box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports